exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.11@core-js/library/modules/_object-gops.js
// module id = 40
// module chunks = 48